/*
 * @FilePath     : /es-package/packages/es-mpx-usex/lib/store.js
 * @Author       : LiYang
 * @Date         : 2022-01-12 19:12:39
 * @LastEditTime: 2023-03-22 11:35:16
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @Description  :
 */
import { createStore, mpx } from '@didi/es-mpx-creator'
import { AEC_ESC_DECTYPT } from '@/common/crypto'
import { trackEvent } from '@/common/track';
import { flush } from './plugin'
import { initLogin } from '../login/login'
import { getStorage } from '@/utils/storage'


let copyStore = null

const store = createStore({
  state: {
    userInfo: getStorage('userInfo') || {},
    token: getStorage('token') || undefined,
    loged: false
  },

  getters: {
    phone(state) {
      if (state.userInfo && state.userInfo.phone) {
        try {
          return AEC_ESC_DECTYPT(state.userInfo.phone) || state.userInfo.phone
        } catch (error) {
          return state.userInfo.phone
        }
      }
    },

    isLogin(state) {
      return !!state.token
    }
  },

  mutations: {
    update(state, { phone, token ,uid}) {
      state.loged = token ? true : false
      state.userInfo = { phone, token ,uid } 
      state.token = token
      setStorage.apply(null, [{userInfo:state.userInfo},{token:state.token}])
      flush()
    }
  },

  actions: {
    getToken({ commit, dispatch }, payload) {
      //获取数据 如果没有获取到 那么就去登陆
      //如果获取到了 那么直接拿着数据去更新 
      return initLogin(payload).then((info)=>{
        commit('update', { ...info })
        return info
      }).catch((err)=>{
        commit('update', {})
      })
    },
  }
})

const setStorage = (target) => {
  Object.keys(target).forEach((key) => {
    const value = target[key]
    if (value) {
      try {
        mpx.setStorageSync(key, value)
      } catch (e) {
        // 埋点 ticket缺失排查
        trackEvent('yks_local_storage_set_or_get_ck', 'yks_local_storage_set_or_get_ck', {
          type: 'set_local_storage_error',
          errtext: e && e.message,
        })
      }
    } else {
      mpx.removeStorageSync(key)
    }
  })
}

store.subscribe(function (mutation) {
  setStorage.apply(null, mutation.payload)
})

export const getStore = () => {
  if (copyStore) {
    return copyStore
  }
  const map = {
    ...store.mapState(['token', 'userInfo']),
    ...store.mapGetters(['phone', 'isLogin'])
  }
  return Object.keys(map).reduce((maper, key) => {
    return Object.defineProperty(maper, key, {
      get: map[key]
    })
  }, (copyStore = {}))
}

export default store
